/**
 * Known id_template_biometric values used for local enrollment.
 * These constants match the backend's template identifiers.
 */

/** Card (RFID/HID) template identifier — primary format. */
export const TEMPLATE_CARD = 3;

/** Card (RFID/HID) template identifier — alternate format. */
export const TEMPLATE_CARD_ALT = 4;

/** PIN template identifier. */
export const TEMPLATE_PIN = 5;

/** Legacy facial photo enrollment template identifier.
 * Defensive housekeeping ONLY — this app's source of truth for facial enrollment
 * is `person_embed_v2`. Reading code MUST NOT rely on this template. */
export const TEMPLATE_FACE_LEGACY = 14;
